/**
 * Registers a new block provided a unique name and an object defining its behavior.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
import { registerBlockType, registerBlockVariation } from '@wordpress/blocks';

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * All files containing `style` keyword are bundled together. The code used
 * gets applied both to the front of your site and to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
// import './style.scss';

/**
 * Internal dependencies
 */
import Edit from './edit';
import Save from './save';
import metadata from './block.json';
import icon from './icon';

/**
 * Every block starts by registering a new block type definition.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */

// Force border support via filter for this block
import { addFilter } from '@wordpress/hooks';

registerBlockType( metadata.name, {
	/**
	 * @see ./edit.js
	 */
	edit: Edit,
	save: Save,
	icon: icon,
} );

// addFilter(
//     'blocks.registerBlockType',
//     'alpha-blocks/force-border-support',
//     ( settings, name ) => {
//       console.log("settings name: ", {settings, name});
//       if ( name === "alphablock/heading" ) {

//           console.log("Insidesettings name: ", {settings, name});

//             settings.supports = settings.supports || {};
//             settings.supports.border = true;
//         }
//         return settings;
//     },
//     9999
// );

/*
const defaultAttributes = Object.entries(metadata.attributes).reduce((acc, [key, value]) => {
  if ('default' in value) {
    acc[key] = value.default;
  }
  return acc;
}, {});

registerBlockVariation(metadata.name, {
  name: 'alphablock/hero_style_main',
  title: 'Hero Style Main',
  description: 'Big heading and call to action',
  attributes: {
    ...defaultAttributes
  },
  isDefault: true,
  icon: 'star-filled',
  scope: ["block", "transform"],
  isActive: ( blockAttributes, variationAttributes ) => blockAttributes.currentStyle === 'alphablock/hero_style_main',
  example: {
    attributes: {
      currentStyle: 'main',
      previewImage: 'https://placehold.co/200x200/transparent/333?text=Main'
    }
  }
});

registerBlockVariation(metadata.name, {
  name: 'alphablock/hero_style_2',
  title: 'Hero Style 2',
  description: 'Big heading and call to action',
  attributes: {
    blockStyle: 'hero',
    backgroundColor: '#f0f0f0',
    currentStyle:'alphablock/hero_style_2',
    heading: 'Header Two',
  },
  isDefault: false,
  icon: 'star-filled',
  scope: ["block", "transform"],
  isActive: ( blockAttributes, variationAttributes ) => blockAttributes.currentStyle === 'alphablock/hero_style_2',
  example: {
    attributes: {
      currentStyle: 'two',
      previewImage: 'https://placehold.co/200x200/transparent/333?text=Style+2'
    }
  }

});

registerBlockVariation(metadata.name, {
  name: 'alphablock/hero_style_3',
  title: 'Hero Style 3',
  description: 'Minimal styling, small padding',
  attributes: {
    blockStyle: 'compact',
    backgroundColor: '#ffffff',
    heading: 'Header Three',
    currentStyle:'alphablock/hero_style_3'
  },
  isDefault: false,
  icon: 'excerpt-view',
  scope: ["block", "transform"],
  isActive: ( blockAttributes, variationAttributes ) => blockAttributes.currentStyle === 'alphablock/hero_style_3',
  example: {
    attributes: {
      currentStyle: 'three',
      previewImage: 'https://placehold.co/200x200/transparent/333?text=Style+3'
    }
  }
});
*/
